export const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.chotsai.chotbuddies';

export const APP_STORE_URL =
  'https://apps.apple.com/us/app/chot-buddies-ai-assistants/id6755300440';
